import axios from "axios";
// import config from "../config/api.config";
import config from "../config"

const apiInstance = axios.create({
  baseURL: config[config.env].baseUrl,
  transformRequest: [data => JSON.stringify(data)],
  transformResponse: [data => JSON.parse(data)]
});

apiInstance.defaults.headers.post["Content-Type"] = "application/json";
apiInstance.defaults.headers.put["Content-Type"] = "application/json";

export default apiInstance;



// WEBPACK FOOTER //
// ./src/common/api.js